import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { getActionsModel } from '../../../services/roles/factdataRoleStatus';
import TableAction from '../../strategyProject/tabs/TabResults/TableAction/TableAction';
import componentStyles from '../../strategyProject/tabs/TabResults/TabResults.module.less';

export function FactDataActions({
  props, actions, userCtx, stratId, policyId, portfId,
}) {
  const {
    id, style, entityType,
  } = props;
  const can = useMemo(() => getActionsModel(props.status, userCtx, stratId, portfId, props.projId, policyId), [props, userCtx, stratId, portfId, policyId]);
  const isTableActionEnabled = useMemo(() => (can.Send || can.Edit || can.Approve || can.Reject || can.Delete || can.Exclude), [can]);
  return isTableActionEnabled ? (

    <TableAction width="350px" style={style} data={props.data} actionsDisabled={!isTableActionEnabled}>
      { can.Send && (
      <Button
        className={componentStyles.actionTableButton}
        onClick={() => actions.send(id)}
        variant="outline-warning"
      >
        Отправить на согласование
      </Button>
      )}
      { can.Edit && (
      <Button
        style={{ width: '100%' }}
        className={componentStyles.actionTableButton}
        onClick={() => actions.edit(id, props)}
        variant="primary"
      >
        Редактировать
      </Button>
      )}
      { can.Approve && (
      <Button
        className={componentStyles.actionTableButton}
        onClick={() => actions.approve(id)}
        variant="outline-success"
      >
        Согласовать
      </Button>
      )}
      { can.Reject && (
      <Button
        className={componentStyles.actionTableButton}
        onClick={() => actions.reject(id)}
        variant="outline-danger"
      >
        Не согласовать
      </Button>
      )}
      { can.Delete
        && (entityType !== 'teamMember' || props.status !== 'approved')
        && (
      <Button
        className={componentStyles.actionTableButton}
        onClick={() => actions.delete(id)}
        variant="outline-danger"
      >
        Удалить
      </Button>
      )}
      { can.Exclude 
        && entityType === 'teamMember'
        && (
      <Button
        className={componentStyles.actionTableButton}
        onClick={() => actions.exclude(id)}
        variant="outline-danger"
      >
        Исключить
      </Button>
      )}
    </TableAction>) : <React.Fragment/>;
};
